import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SyncSettingsPanel from "./SyncSettingsPanel";
import OutlineConnectionPanel from "./OutlineConnectionPanel";
import AgentAccessPanel from "./AgentAccessPanel";
import { CurrentUser, displayNameFor, fetchCurrentUser } from "../utils/user";

/**
 * Settings live behind the account menu rather than on the list view, so the
 * main screen stays about links.
 */
const SettingsView: React.FC = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<CurrentUser | null>(null);

  useEffect(() => {
    let mounted = true;
    void fetchCurrentUser().then((result) => {
      if (mounted) setUser(result);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      <button
        type="button"
        className="back-button"
        onClick={() => navigate("/")}
      >
        <i className="fas fa-arrow-left" aria-hidden="true" /> Back
      </button>

      {user && (
        <section className="app-section">
          <div className="app-card">
            <h2 className="app-title">Account</h2>
            <dl className="settings-account">
              <dt>Signed in as</dt>
              <dd>{displayNameFor(user)}</dd>
              {user.email && (
                <>
                  <dt>Email</dt>
                  <dd>{user.email}</dd>
                </>
              )}
              {user.groups.length > 0 && (
                <>
                  <dt>Groups</dt>
                  <dd>{user.groups.join(", ")}</dd>
                </>
              )}
            </dl>
          </div>
        </section>
      )}

      <OutlineConnectionPanel />
      <SyncSettingsPanel />

      <AgentAccessPanel />
    </>
  );
};

export default SettingsView;
